/* Intro text block — opens the dashboard body right under the hero banner.
   Same eyebrow + serif title + description treatment as the astrology app's
   gallery header, with dashboard-relevant copy and the dashboard palette. */
export default function DashboardIntro() {
  return (
    <section className="mb-8">
      <div className="max-w-2xl">
        <span className="flex items-center gap-2 mb-2">
          <span className="w-6 h-px bg-goldAccent/60" />
          <span className="text-[9px] font-bold tracking-[0.3em] uppercase text-goldAccent font-royal">Your Sacred Space</span>
        </span>
        <h2 className="text-2xl sm:text-3xl font-royal text-[#3D0A0A] leading-tight uppercase">
          Your Spiritual <span className="text-goldAccent">Journey</span>
        </h2>
        <p className="text-xs text-stone-500 font-light mt-2">
          Consultations, kundli insights, courses, orders and remedies — everything on your path, gathered in one place.
        </p>
      </div>
    </section>
  )
}
